module.exports = __webpack_public_path__ + "packs/media/images/Chat_Icon-8dfa862667281bf8b783b49198b1b21f.svg";